// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1837":"ca66fd1157ee95bf","2146":"ca66fd1157ee95bf","2888":"6d271fd428a2488d","6845":"bb316c81c50a5d4c","8344":"ca66fd1157ee95bf"}[chunkId] + ".css";
};